(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '@peachjar/ui'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('@peachjar/ui'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.ui);
    global.SubappContainer = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _ui) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    max-width: 1140px;\n    min-width: 1140px;\n    margin: 0;\n\n    @media screen and (min-width: ', ') {\n      margin: auto;\n    }\n  '], ['\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    max-width: 1140px;\n    min-width: 1140px;\n    margin: 0;\n\n    @media screen and (min-width: ', ') {\n      margin: auto;\n    }\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    padding: 0rem 0.85rem;\n\n    @media screen and (min-width: ', ') {\n      padding: 0rem 1.5rem;\n    }\n  '], ['\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    padding: 0rem 0.85rem;\n\n    @media screen and (min-width: ', ') {\n      padding: 0rem 1.5rem;\n    }\n  ']);

  var SubappContainer = function SubappContainer(_ref) {
    var children = _ref.children,
        className = _ref.className,
        innerClassName = _ref.innerClassName;
    return React.createElement(
      'div',
      { className: (0, _reactEmotion.cx)(classNames.containerPadding, className) },
      React.createElement(
        'div',
        { className: classNames.container + ' ' + innerClassName },
        children
      )
    );
  };

  SubappContainer.defaultProps = { className: '', innerClassName: '' };

  var classNames = {
    container: (0, _reactEmotion.css)(_templateObject, _ui.BREAKPOINTS.md),
    containerPadding: (0, _reactEmotion.css)(_templateObject2, _ui.BREAKPOINTS.md)
  };

  exports.default = SubappContainer;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/SubappContainer.js
// module id = 2022
// module chunks = 1